export const APP_ORDER_DEAL_STATUS_PERMISSION = {
  VIEW: 'SYS_APPCONFIG_VIEW',
  ADD: 'SYS_APPCONFIG_ADD',
  EDIT: 'SYS_APPCONFIG_EDIT',
  DEL: 'SYS_APPCONFIG_DEL',
};

export const APP_ORDER_DEAL_STATUS_ACTIVE_OPTIONS = [
  { value: 1, label: 'Kích hoạt' },
  { value: 0, label: 'Ẩn' },
];

export const APP_ORDER_DEAL_STATUS_DEFAULT_VALUES = {
  status: '',
  status_name: '',
  text_color: '#C47A00',
  background_color: '#FFF3CD',
  sort_order: 0,
  is_success: 0,
  is_failure: 0,
  is_final: 0,
  is_active: 1,
};
